module.exports = "https://coursera_assets.s3.amazonaws.com/images/c3586deab8e3bda3fdd1b00b65094508.png";